module.exports = "<div class=\"copyright text-align-center\">\n  Copyright &copy; 2019 Rose Pharmacy. All Rights Reserved.\n</div>"